import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VouchersApi from '../../../api/open-voucher';
import PaymentApi from '../../../api/payment';
import VoucherInfo from './voucher-info';
import Producto from './productos/producto';
import Tabs from '../../tabs/index';
import Faqs from '../faqs';
import { addPromotions } from '../../../redux/actions/selectActions';
import Filtros from './filtros';
import GMapMarkerList from '../../../helpers/g-map-list-markers';
import './index.css';

class VoucherProductos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      ofertas: null,
      productos: null,
      productosFiltrados: [],
      indexOfertaSeleccionada: null,
      error: { status: false, msg: '' },
    };
    this.handleOnChangeNights = this.handleOnChangeNights.bind(this);
    this.obtenerDatosProductos = this.obtenerDatosProductos.bind(this);
    this.actualizarProductos = this.actualizarProductos.bind(this);
  }

  async componentDidMount() {
    const { app } = this.props;
    const { token } = app;
    await this.obtenerDatosProductos(token);
  }

  obtenerPartesDePathname = () => {
    const pathname = window.location.pathname.replace('/buscarxpaquetes', '');

    const path = pathname[pathname.length - 1] === '/'
      ? pathname.substring(0, pathname.length - 1)
      : pathname;

    return path.split('/');
  }

  async obtenerDatosProductos(token) {
    const { actions } = this.props;
    const [,,, idTipo, idVoucher] = this.obtenerPartesDePathname();

    const vouchers = await VouchersApi.getVouchers(token).then((data) => {
      if (data.status) {
        return data.object.ofertas;
      }
      return false;

    });
    const productos = await VouchersApi.getProductsByTypeVoucherId(idTipo, token).then((data) => {
      if (data.status) {
        return data.object;
      }
      return false;

    });

    await PaymentApi.obtenerOpcionesPagoMundigea(token).then((res) => {
      actions.addPromotions(res.data);
    });

    if (vouchers && vouchers.length > 0) {
      const vouchersPorTipo = vouchers.filter((voucher) => parseInt(voucher.tipoVoucherId) === parseInt(idTipo));

      const ordenedVoucherdOptions = vouchersPorTipo.sort((a, b) => {
        return a.usoVoucher.cantidadUsos - b.usoVoucher.cantidadUsos;
      });

      let indexSelected = 0;

      ordenedVoucherdOptions.forEach((oferta, index) => {
        if (parseInt(oferta.id) === parseInt(idVoucher)) {
          indexSelected = index;
        }
      });
      const randomOrderProducts = productos.default.sort(() => 0.5 - Math.random());
      this.setState({
        ofertas: ordenedVoucherdOptions,
        indexOfertaSeleccionada: indexSelected,
        productos: randomOrderProducts,
        loading: false,
      });
    } else {
      this.setState({
        error: { status: true, msg: 'No encontramos lo que buscabas :S' },
        loading: false,
      });
    }
  }

  handleOnChangeNights(newIndex) {
    this.setState({
      indexOfertaSeleccionada: newIndex,
    });
  }

  actualizarProductos(newList) {
    this.setState({
      productosFiltrados: newList,
    });
  }

  createSkeleton = () => {
    return (
      <>
        <br />
        <br />
        <img
          src='https://www.mundigea.com.ar/buscarxpaquetes/assets/img/loader2.gif'
          alt=''
          className='img-responsive center-block'
          style={{ height: 110, marginBottom: 42 }}
        />
      </>
    );
  }

  render() {
    const { productos, productosFiltrados, ofertas, indexOfertaSeleccionada, loading, error } = this.state;
    const listaFiltros = [
      {
        labelKey: 'categoria',
        label: 'Categoria',
        getData: (item) => {
          return item.producto.categoria;
        },
      },
      {
        labelKey: 'extras',
        label: 'Regimen',
        getData: (item) => {
          return item.producto.extras;
        },
      },
      {
        labelKey: 'localidad',
        label: 'Localidad',
        getData: (item) => {
          return `${item.producto.localidad}, ${item.producto.provincia}`;
        },
      },

    ];
    const crearListaProductos = () => {
      if (loading) {
        return this.createSkeleton();
      }
      if (productos && ofertas && error.status === false) {
        const mobile = window.innerWidth < 1000;
        const voucher = ofertas[indexOfertaSeleccionada];
        return (
          <>
            <div className='panel-group' id='accordion' role='tablist' aria-multiselectable='true'>
              <div className='col-md-12'>
                <div className='panel map'>
                  <div id='collapseOne' className='panel-collapse collapse' role='tabpanel' aria-labelledby='headingOne'>
                    <div className='maps-container'>
                      <GMapMarkerList
                        mapOptions={{
                          mapTypeControl: false,
                        }}
                        listMarkers={
                          productosFiltrados.map((item) => ({
                            lat: parseFloat(item.producto.latitud),
                            lng: parseFloat(item.producto.longitud),
                            name: item.producto.nombre,
                            urlDetails: `${process.env.RAZZLE_URL_PATH}/open-voucher/producto-detalle/${voucher.tipoVoucher.id}/${voucher.id}/${item.producto.id}`,
                          }))
                        }
                        markerInfo={
                          (item) => (
                            <div className='marker-info'>
                              <h5 className='info-title'>{item.name}</h5>
                              <a
                                target='_blank'
                                rel='noopener noreferrer'
                                className='btn info-url color-dinamico-fondo center-block'
                                href={item.urlDetails}
                              >
                                Ver detalle
                              </a>
                            </div>
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-3'>
                <div className='prods-count'>
                  {productosFiltrados.length}
                  {' '}
                  producto
                  {productosFiltrados.length > 1 || productosFiltrados.length === 0 ? 's' : '' }
                </div>
                <div className='toggles-container'>
                  {mobile
                    ? (
                      <>
                        <div
                          className='btn button-map color-dinamico-fondo-claro'
                          role='button'
                          data-toggle='collapse'
                          data-parent='#accordion'
                          href='#collapseOne'
                          aria-expanded='false'
                          aria-controls='collapseTwo'
                        >
                          <i className='fa fa-map-o' />
                          {' '}
                          Ver mapa
                        </div>
                      </>
                    )
                    : (
                      <>
                        <h4>Vista mapa</h4>
                        <div
                          className='button-map-container'
                          role='button'
                          data-toggle='collapse'
                          data-parent='#accordion'
                          href='#collapseOne'
                          aria-expanded='false'
                          aria-controls='collapseTwo'
                        >
                          <div className='icon-container'>
                            <i className='fa fa-expand' />
                          </div>
                          <img src='https://res.mundigea.com.ar/img/recursos/map6.png' className='img-map' alt='map' />
                        </div>
                      </>
                    )}
                  {mobile && (
                    <div
                      className='btn botton-filters color-dinamico-fondo-claro'
                      role='button'
                      data-toggle='collapse'
                      data-parent='#accordion'
                      href='#collapseTwo'
                      aria-expanded='true'
                      aria-controls='collapseOne'
                    >
                      <i className='fa fa-filter' />
                      {' '}
                      Filtros
                    </div>
                  )}
                </div>
                <div className='panel filtros'>
                  <div id='collapseTwo' className={`panel-collapse collapse ${mobile ? '' : 'in'}`} role='tabpanel' aria-labelledby='headingTwo'>
                    <Filtros
                      items={productos}
                      updateListItems={(list) => this.actualizarProductos(list)}
                      filters={listaFiltros}
                    />
                  </div>
                </div>
              </div>
              <div className='col-md-9'>
                {productosFiltrados.map((producto) => (
                  <Producto
                    key={producto.id}
                    data={producto}
                    ofertaVoucherData={ofertas[indexOfertaSeleccionada]}
                  />
                ))}
                { productosFiltrados.length === 0 && productos.length > 0 && (
                  <>
                    <br />
                    <br />
                    <br />
                    <h3 className='text-center'>No se encontraron productos</h3>
                  </>
                )}
              </div>
            </div>

          </>

        );
      }
      return (
        <>
          <br />
          <h2 className='text-center'>No encontramos productos para este voucher :c</h2>
        </>
      );

    };

    return (
      <>
        <Tabs />
        <Faqs />
        <VoucherInfo
          indexSelected={indexOfertaSeleccionada}
          voucherOfertas={ofertas}
          onNightsChange={this.handleOnChangeNights}
        />
        <div className='container'>
          {crearListaProductos()}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.applicationState,
});

const mapDispatchToProps = function (dispatch) {
  return {
    actions: bindActionCreators({ addPromotions }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherProductos);
